import { useEffect, useState } from 'react'
import { SecureFileModel, SecureFileStatusModel } from '../../models/secure-file';
import { ActionLabels, DialogHeaders, GridStatusLabelVariant, ToasterTexts, appNote, buttonLabels, emptyLabels } from '../shared/constants';
import { CancelIcon, CopyLinkIcon, DoubleArrowWhiteIcon, InfoSecondaryIcon, ReportsGroupGridIcon, ReportsScheduledGridIcon, SucessOutlineIcon, TrashIcon } from '../../icon';
import GridComponent from "../shared/grid";
import { ColDef, ValueGetterParams, ICellRendererParams, CellClickedEvent, GridApi } from 'ag-grid-community';
import { UtilityService } from '../../services/UtilityService';
import { HeaderTemplate, dateComparator } from '../shared/grid/grid.services';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { SecureFileService } from '../../services/SecureFileService';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { CustomFilterCategory } from '../shared/filters/filter.model';
import { DisplayMediaIcon } from './display-media.component';
import _ from 'lodash';
import { UserService } from '../../services/UserService';
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useDispatch } from "react-redux";
import ConfirmDialog from "../shared/confirm-dialog.component";
import ViewSecureFile from "./view-secure-file.component";
import { LoadSecureFiles, LoadSecureFileLinks } from '../../actions';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from '@mui/material';
import ButtonComponent from '../shared/button/button.component';
import { PlanMetrics } from '../../models/plan-metrics.model'
import Avatar from '../shared/avatar.component';
import { TypeRenderer } from '../shared/grid/typeRendrer';
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';

interface Props {
    onGridReady: (params: any) => void,
    ContactIDs?: string[];
    OnSelectionChanged: (data: any) => void

}

interface IProps extends Props {
    ContactIDs?: string[];
}

const SecureFile = (props: Props) => {

    const dispatch = useDispatch()
    let id = { "user_id": UserService.getCurrentUserId() }
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const Contacts: any = useSelector(selector.contacts)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const SecureFiles: SecureFileModel[] = useSelector(selector.secureFiles)
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)
    const [gridApi, setGridApi] = useState<GridApi>();
    const [columnApi, setcolumnApi] = useState<any>(null)


    const [showDeleteConfirmDialog, SetShowDeleteConfirmDialog] = useState<boolean>(false)
    const [clickedRowFileName, setClickRowFileName] = useState<string>("")
    const [buttonName, setButtonName] = useState<string>("")
    const [showGetLinkDialog, setShowGetLinkDialog] = useState<boolean>(false)
    const [getUrlLink, setGetUrlLink] = useState<string>("")
    const [faceUrlLink, setFaceUrlLink] = useState<string>("")
    const [copyStatus, setCopyStatus] = useState({ urlCopied: false, faceUrlCopied: false })
    const [showManageAcessDialog, setShowManageAccessDialog] = useState<boolean>(false)
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([])
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([])
    const [showViewDetailDialog, setShowViewDetailDialog] = useState<boolean>(false)
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [clickedRowId, setClickedRowId] = useState<string>("")
    // const [selectedFiles , setSelectedFiles] = useState<SecureFileModel>()

    const closeViewDetailDialog = (openManageAccess?: boolean) => {
        if (openManageAccess) {
            setShowManageAccessDialog(true)
        }
        setShowViewDetailDialog(false)
    }

    const closeDeleteConfirmDialog = (confirm) => {
        if (confirm) {
            setIsLoading(true)
            let data = {
                "id": clickedRowId,
                "file_name": clickedRowFileName,
                "user_id": UserService.getCurrentUserId()
            }
            SecureFileService.deleteSecureFile(data).then(() => {
                LoadSecureFiles(dispatch, id)
                LoadSecureFileLinks(dispatch)
                setIsLoading(false)
                setToast(ToasterTexts.SECURE_FILE_DELETE_SUCCESS.replace("<Name>", clickedRowFileName), ToasterType.SUCCESS);

            }).catch(err => {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                setIsLoading(false)
            })
        }
        SetShowDeleteConfirmDialog(false)
        setClickRowFileName("")
        setButtonName("")
        resetFilters()
    }

    const SecureFileColoumnDefs: ColDef[] = [
        {
            field: "FileName",
            headerName: "File Name",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.FileName
            },
            cellRenderer: (params) => {
                let name = params.data.FileName.substring(0, params.data.FileName.lastIndexOf("."))
                return <div className='d-flex align-center'>
                    <DisplayMediaIcon FileName={params.data.FileName} />
                    <span className='ml-1'>{UtilityService.trimMessage(name, 16)}</span>

                </div>
            },
            headerCheckboxSelection: IsMobileDevice ? false : true,
            checkboxSelection: IsMobileDevice ? false : true,
        },
        {
            field: "UserName",
            headerName: "Owner",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.UserName
            },
            hide: IsMobileDevice,
        },
        {
            field: "Email Authentication",
            headerName: "Email Authentication",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SharedEmails
            },
            cellRenderer: (params) => {
                const emails = params.value
                return (
                    <div className="d-flex align-center">
                        {emails?.slice(0, 5)?.map((email, index) => {
                            const initials = email.substring(0, 2).toUpperCase()
                            return (
                                <Tooltip key={index} title={email} placement="top">
                                    <span className='c-pointer mrn-1'>
                                        <Avatar Name={initials} Size={28} />
                                    </span>
                                </Tooltip>
                            )
                        })}
                        {emails?.length > 5 && (
                            <Tooltip
                                placement="right-start"
                                title={(emails?.slice(5)?.map((email, index) => {
                                    return <div className='h4-regular'>{email}</div>
                                }))}
                            >
                                <span className="ml-2 br-5 w-4 h-4 d-flex align-center justify-center bg-color-secondary-btn-highlight-hover c-pointer">+{emails?.length - 5}</span>
                            </Tooltip>
                        )}
                    </div>
                )
            },
            hide: IsMobileDevice,
        },
        {
            field: "Face Authentication",
            headerName: "Face Authentication",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SharedFaces;
            },
            cellRenderer: (params) => {
                const faces = params.value
                return (
                    <div className="d-flex align-center">
                        {faces.slice(0, 5)?.map((face, index) => {
                            const initials = face.substring(0, 2).toUpperCase();
                            return (
                                <Tooltip key={index} title={face} placement="top">
                                    <span className='c-pointer mrn-1'>
                                        <Avatar Name={initials} Size={28} />
                                    </span>
                                </Tooltip>
                            )
                        })}
                        {faces?.length > 5 && (
                            <Tooltip
                                placement="right-start"
                                title={(faces?.slice(5)?.map((face, index) => {
                                    return <div className='h4-regular'>{face}</div>
                                }))}
                            >
                                <span className="ml-2 br-5 w-4 h-4 d-flex align-center justify-center bg-color-secondary-btn-highlight-hover c-pointer">+{faces?.length - 5}</span>
                            </Tooltip>
                        )}
                    </div>
                )
            },
            hide: (IsMobileDevice || !PlanMetrics?.HasAccessToFaceVault),
        },
        {
            field: "Isreadonly",
            headerName: "Document Permission",
            valueGetter: (params: ValueGetterParams) => { return params.data.IsReadOnly ? "Read Only" : " DownLoad Only" },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.IsReadOnly ? "Read Only" : "Download Only";
                    const icon = params.data.IsReadOnly ? ReportsGroupGridIcon : ReportsScheduledGridIcon;
                    const Status = {
                        component: TypeRenderer,
                        params: {
                            Icon: icon, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
        },
        {
            field: "Status",
            headerName: "Status",
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => { return params.data.Status === SecureFileStatusModel.Active ? SecureFileStatusModel.Active : SecureFileStatusModel.Expired },

            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status;
                    const variant = params.data.Status === SecureFileStatusModel.Active ? GridStatusLabelVariant.Active : GridStatusLabelVariant.Danger;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
        },
        {
            field: "UpdatedDate",
            headerName: "Updated Date",
            sort: "desc",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.UpdatedDate)
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.UpdatedDate, nodeB.data.UpdatedDate),
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={getMenuActions(params.data)}
                {...params}
            />,
            resizable: false,
            hide: IsMobileDevice,
            sortable: false,
        },
    ]

    const getMenuActions = (data: SecureFileModel) => {
        return [
            {
                Name: ActionLabels.MANAGE_ACCESS,
                Icon: InfoSecondaryIcon,
                Hide: false,
                OnClick: () => openViewDetailDialog(data.Id, data.FileName)
            },
            {
                Name: ActionLabels.GET_LINK,
                Icon: CopyLinkIcon,
                Hide: data.Status === SecureFileStatusModel.Expired,
                OnClick: () => openGetLinkDialog(data.Id, data.FileName)
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                Hide: false,
                OnClick: () => openDeleteConfirmDialog(data.Id, data.FileName)
            }
        ]
    }

    const openViewDetailDialog = (Id: string, fileName: string) => {
        setClickedRowId(Id)
        setClickRowFileName(fileName)
        setShowViewDetailDialog(true)
    }

    const openGetLinkDialog = (Id: string, fileName: string) => {
        let data = {
            "id": Id,
            "user_id": UserService.getCurrentUserId(),
            "file_name": fileName
        }
        SecureFileService.getUrlLink(data).then((res) => {
            if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                setGetUrlLink(res.data.url)
                setFaceUrlLink(res.data.faceUrl)
            }
            else {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
            }
        }).catch((err) => {
            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
        })
        setShowGetLinkDialog(true)
        setClickedRowId(Id)
        setClickRowFileName(fileName)
        setCopyStatus({ urlCopied: false, faceUrlCopied: false })
    }

    const openDeleteConfirmDialog = (Id: string, fileName: string) => {
        SetShowDeleteConfirmDialog(true)
        setClickedRowId(Id)
        setClickRowFileName(fileName)
        setButtonName("Delete")
    }

    useEffect(() => {
        LoadSecureFiles(dispatch, id)
    }, [])

    const initialFilterOptions = () => {
        const filterData: any[] = [
            {
                Id: 1,
                Title: 'Status',
                IsSelectedAll: false,
                Options: _(SecureFiles)
                    .map((row, index) => ({
                        Key: "Status",
                        Id: index + 1,
                        Label: row.Status === SecureFileStatusModel.Active ? "Active" : "Expired",
                        Value: row.Status,
                        IsSelected: false,
                    }))
                    .uniqBy('Label')
                    .value()
            },
        ]
        setFilterOptions(filterData)
    }

    useEffect(() => {
        initialFilterOptions()
    }, [SecureFiles])

    const resetFilters = () => {
        setFilterOptions([])
        setSelectedFilterTypes([])
        initialFilterOptions()
    }

    const closeGetLinkDialog = () => {
        setShowGetLinkDialog(false)
        setCopyStatus({ urlCopied: false, faceUrlCopied: false })
        setGetUrlLink("")
        setClickRowFileName("")
    }

    const copyToClipboard = (text, isTeamsApp, fallbackCopyMethod) => {
        if (isTeamsApp) {
            fallbackCopyMethod(text);
        } else {
            navigator.clipboard.writeText(text);
        }
    }

    const copyEmailLink = () => {
        setCopyStatus({ urlCopied: true, faceUrlCopied: false });
        copyToClipboard(getUrlLink, IsTeamsApp, copyTextFallback);
    }

    const copyFaceLink = () => {
        setCopyStatus({ urlCopied: false, faceUrlCopied: true });
        copyToClipboard(faceUrlLink, IsTeamsApp, copyTextFallback);
    }

    const copyTextFallback = (text) => {
        const newElement = document.createElement("div");
        newElement.textContent = text;
        document.body.appendChild(newElement);
        const range = document.createRange();
        range.selectNode(newElement);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("copy");
        document.body.removeChild(newElement);
    }

    const handleCellRowClick = (e: any, row: SecureFileModel) => {
        if (!IsMobileDevice && e.colDef.field !== "Action") {
            openViewDetailDialog(row.Id, row.FileName)
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setcolumnApi(params.columnApi)
        props.onGridReady(params);
    }

    const onSelectionChanged = () => {
        let SelectedFiles: SecureFileModel[] = gridApi.getSelectedRows()
        if (gridApi) {
            props.OnSelectionChanged(SelectedFiles)
        }
    }

    return (
        <>
            <div className="d-flex flex-direction h-p-100 justify-between">
                <GridComponent
                    ColumnDefs={SecureFileColoumnDefs}
                    RowData={SecureFiles}
                    OnGridReady={onGridReady}
                    IsPaginationEnabled={!IsMobileDevice}
                    OnGridRowClick={(e) => { }}
                    EmptyLabel={emptyLabels.SECURE_FILES}
                    filterOptions={filterOptions}
                    IsFilterPresent={true}
                    LockVisible={false}
                    OnGridCellRowClick={handleCellRowClick}
                    ShowRowPointer={true}
                    OnSelectionChanged={onSelectionChanged}
                />
            </div>
            {
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={showGetLinkDialog}
                    onClose={() => closeGetLinkDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: "br-2 w-p-35 " }}
                    disableEscapeKeyDown
                >
                    <DialogTitle className='bg-color-primary-background'>
                        <div className='d-flex justify-between align-center mt-1'>
                            <span className='d-flex align-center'>
                                <SucessOutlineIcon className='w-4' />
                                <span className='ml-2 h3-semibold color-secure-file-dialog-title'>
                                    {DialogHeaders.CREATE_LINK.replace("<FileName>", UtilityService.trimMessage(clickedRowFileName, 30))}
                                </span>
                            </span>
                            <CancelIcon onClick={() => closeGetLinkDialog()} className="c-pointer" />
                        </div>
                    </DialogTitle>
                    <div className='h4-semibold ml-4 mt-1'>Email Link</div>
                    <DialogContent className='p-0 mx-4 mt-1' >
                        <TextField
                            disabled
                            size='small'
                            fullWidth
                            className='p-0'
                            variant="outlined"
                            value={getUrlLink}
                            InputProps={{ classes: { input: `h4-regular color-secure-file-dialog-title` } }}
                        />
                    </DialogContent>
                    <DialogActions className='pr-4'>
                        <ButtonComponent ButtonLabel={copyStatus.urlCopied ? buttonLabels.COPIED : buttonLabels.COPY} Variant={"secondary-btn"} ClassName='float-right mb-0 h5-regular ' OnClick={copyEmailLink} />
                    </DialogActions>
                    {PlanMetrics?.HasAccessToFaceVault &&
                        <>
                            <div className='h4-semibold ml-4 mt-1'>Face Authentication Link</div>
                            <DialogContent className='p-0 mx-4 mt-1 '>
                                <TextField
                                    size='small'
                                    className='p-0'
                                    disabled
                                    fullWidth
                                    variant="outlined"
                                    value={faceUrlLink}
                                    InputProps={{ classes: { input: `h4-regular color-secure-file-dialog-title` } }}
                                />
                            </DialogContent>
                            <DialogActions className='pr-4'>
                                <ButtonComponent ButtonLabel={copyStatus.faceUrlCopied ? buttonLabels.COPIED : buttonLabels.COPY} Variant={"secondary-btn"} ClassName='float-right mb-0 h5-regular ' OnClick={copyFaceLink} />
                            </DialogActions>
                        </>
                    }
                    <div className='ml-4 mb-4 h2-regular color-primary-accent t-decoration-underline d-flex align-center'>
                        <span onClick={() => { openViewDetailDialog(clickedRowId, clickedRowFileName); closeGetLinkDialog() }} className='c-pointer'>{ActionLabels.MANAGE_ACCESS}</span>
                        <DoubleArrowWhiteIcon className='ml-1 w-3 c-pointer' onClick={() => { openViewDetailDialog(clickedRowId, clickedRowFileName); closeGetLinkDialog() }} />
                    </div>
                </Dialog>
            }
            {
                showDeleteConfirmDialog && (
                    <ConfirmDialog
                        onClose={closeDeleteConfirmDialog}
                        Show={showDeleteConfirmDialog}
                        Text={appNote.SECURE_FILE}
                        ButtonName={buttonName}
                        Loading={IsLoading}
                    />
                )
            }
            {
                showViewDetailDialog &&
                <ViewSecureFile
                    Id={clickedRowId}
                    Show={showViewDetailDialog}
                    FileName={clickedRowFileName}
                    OnClose={closeViewDetailDialog}
                />
            }
        </>
    )
}
export default SecureFile;